import {
  Building2,
  FileCheck,
  Home,
  Settings,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';

export type CommandActionType = 'navigation' | 'callback';

export type CommandAction = {
  type: CommandActionType;
  payload: string | (() => void);
};

export type CommandShortcut = string;

export type Command = {
  id: string;
  label: string;
  description?: string;
  icon: LucideIcon;
  shortcut?: CommandShortcut;
  global: boolean;
  action: CommandAction;
};

export type CommandGroup = {
  id: string;
  label: string;
  commands: Command[];
};

// Navigation Commands
export const NAVIGATION_COMMANDS: Command[] = [
  {
    id: 'nav-dashboard',
    label: 'Ir para home',
    icon: Home,
    global: true,
    action: {
      type: 'navigation',
      payload: '/dashboard',
    },
  },
  {
    id: 'nav-advisories',
    label: 'Ir para assessorias',
    icon: Building2,
    global: true,
    action: {
      type: 'navigation',
      payload: '/advisories',
    },
  },
  {
    id: 'nav-brokers',
    label: 'Ir para corretores',
    icon: Users,
    global: true,
    action: {
      type: 'navigation',
      payload: '/brokers',
    },
  },
  {
    id: 'nav-users',
    label: 'Ir para usuários',
    icon: Users,
    global: true,
    action: {
      type: 'navigation',
      payload: '/settings/users',
    },
  },
  {
    id: 'nav-policies',
    label: 'Ir para apólices',
    icon: FileCheck,
    global: true,
    action: {
      type: 'navigation',
      payload: '/policies',
    },
  },
  {
    id: 'nav-settings',
    label: 'Ir para configurações',
    icon: Settings,
    global: true,
    action: {
      type: 'navigation',
      payload: '/settings',
    },
  },
];

// Action Commands
export const ACTION_COMMANDS: Command[] = [
  {
    id: 'action-add-user',
    label: 'Adicionar novo usuário',
    icon: UserPlus,
    global: true,
    action: {
      type: 'navigation',
      payload: '/settings/users?newUser=true',
    },
  },
];

// Get all command groups
export const getCommandGroups = (): CommandGroup[] => {
  const groups: CommandGroup[] = [
    {
      id: 'navigation',
      label: 'Navegação',
      commands: NAVIGATION_COMMANDS,
    },
    {
      id: 'actions',
      label: 'Ações',
      commands: ACTION_COMMANDS,
    },
  ];

  return groups;
};
